export const gitCommit = 'dbabd54e'
